import React, { Suspense } from 'react';

import { RecentlyViewedSimilarProductList } from '~/domains/search/RecentlyViewedSimilarProducts';

import { AdRecommendKeywordList } from './AdRecommendKeywordList';
import { PopularSearchKeywordList } from './PopularSearchKeywordList';
import { RecentSearchKeywordList } from './RecentSearchKeywordList';

function EntryProductSearch() {
  return (
    <Suspense fallback={null}>
      <main className="mt-16 flex flex-col gap-16 pb-24">
        <RecentSearchKeywordList />
        <AdRecommendKeywordList />
        <RecentlyViewedSimilarProductList />
        <PopularSearchKeywordList />
      </main>
    </Suspense>
  );
}

export default EntryProductSearch;
